import LayoutWrapper from '@/features/orders/components/Tabs/parts/LayoutWrapper'
import TopTabs from '@/features/ui/components/TopTabs'
import { Tab } from '@/features/ui/navigation'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Tabs: FC = () => {
    const { t } = useTranslation()

    return (
        <TopTabs
            layout={({ children }) => <LayoutWrapper>{children}</LayoutWrapper>}
            screenOptions={{ swipeEnabled: true }}
        >
            <TopTabs.Screen
                name="index"
                options={{
                    tabBarLabel: ({ focused }) => (
                        <Tab active={focused}>{t('archiveTabs.all')}</Tab>
                    ),
                }}
            />
        </TopTabs>
    )
}

export default Tabs
